var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content
    ? _c(
        "div",
        {
          staticClass: "cookie-consent",
          class: { active: _vm.active },
          style: { height: _vm.calculatedHeight }
        },
        [
          _c(
            "div",
            {
              ref: "front",
              staticClass: "consent-front",
              class: { active: _vm.state === 0 }
            },
            [
              _c("div", { staticClass: "consent-front-h" }, [
                _c("span", [_vm._v(_vm._s(_vm.content.h))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "consent-actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "consent-help",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.state = 1
                      }
                    }
                  },
                  [_vm._v("Customise")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "consent-btn",
                    style: { "background-color": _vm.colour },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.agree($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.content.btn))]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "back",
              staticClass: "consent-back",
              class: { active: _vm.state === 1 }
            },
            [
              _c("div", { staticClass: "consent-back-d" }, [
                _c("div", {
                  staticClass: "consent-back-d-p",
                  domProps: { innerHTML: _vm._s(_vm.content.p_1) }
                }),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.analytics === "on"
                ? _c("div", { staticClass: "consent-back-d" }, [
                    _c("div", {
                      staticClass: "consent-back-d-p",
                      domProps: { innerHTML: _vm._s(_vm.content.p_2) }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "switch" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.analyticsInput,
                            expression: "analyticsInput"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.analyticsInput)
                            ? _vm._i(_vm.analyticsInput, null) > -1
                            : _vm.analyticsInput
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.analyticsInput,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.analyticsInput = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.analyticsInput = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.analyticsInput = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "switch-btn" })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "consent-actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "consent-help",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.state = 0
                      }
                    }
                  },
                  [_vm._v("Back")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "consent-btn",
                    style: { "background-color": _vm.colour },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.agree($event)
                      }
                    }
                  },
                  [_vm._v("Confirm")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "consent-analytics" } })
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "switch" }, [
      _c("input", { attrs: { type: "checkbox", disabled: "", checked: "" } }),
      _vm._v(" "),
      _c("span", { staticClass: "switch-btn disabled" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }